<template>
	<table class="dw-table">
		<thead>
			<tr>
				<th style="width: 40px !important"></th>
				<th>Request ID</th>
				<th>Download Link</th>
				<th>By Who</th>
				<th>For Customer</th>
				<th>Item(s)</th>
				<th>Date</th>
				<th>
					<div>
						<button class="btn btn--red dw-table__btn">Clear All</button>
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="eachDownload in downloadList" :key="eachDownload.rid">
				<td style="width: 40px"><img v-if="eachDownload.clickdt == null" class="redflag" src="@/assets/red-flag.svg" alt="Undownloaded Item"  /></td>
				<td>{{ eachDownload.rid }}</td>
				<td>
					<button class="btn btn--blue dw-table__btn" v-on:click="openLink(eachDownload.rid)">Download</button>
				</td>
				<td>{{ eachDownload.handler }}</td>
				<td>{{ eachDownload.provider_selected }}</td>
				<td>{{ eachDownload.serial_nos }}</td>
				<td>{{ eachDownload.downloaddt }}</td>
				<td>
					<button class="btn btn--red dw-table__btn">Clear</button>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
	name: "DownloadTable",
	components: {},
	data() {
		return {
		downloadList: {},
		selected: '',
		};
	},
	mounted() {
		{

			this.getDownloadList();
		}
	},
	methods: {
		getDownloadList() {
			axios.get('https://new.colorwayrb.com/backend/download_list.php?sessionid=' + this.$store.getters.sessionid ).then(response => {
				this.downloadList = response.data;
				console.log(response.data);
				
			});
		},
		openLink(url) {
			location.href = 'https://new.colorwayrb.com/backend/clickdownload.php?downloadid=' + url;
			
		
		},
	}
	
});
</script>

<style lang="scss" scoped>
.dw-table {
	margin: 0 auto;

	th,
	td {
		border: 1px solid $border-color;
	}

	th {
		background-color: $color7;
		text-transform: uppercase;
		font-weight: 600;
		line-height: 17px;
		font-size: 14px;
		padding: 6px 0;
		width: 191px;
	}

	td {
		text-align: center;
		padding: 6px 0;
		font-size: 14px;
	}

	&__btn {
		text-transform: uppercase;
		border-radius: 5px;
		padding: 3px 15px;
		font-weight: 600;
		font-size: 12px;
	}
	
	.redflag {
		height: 30px;
	}
}
</style>
